module.exports = __webpack_public_path__ + "static/media/right-arrow.b246f3fc.svg";